<template>
<div class="inoutdetail" name="inoutdetail">
  <!-- <topNav v-show="topShow" :title="title"></topNav> -->
  <img class="carpic" :src=carpic v-lazy="carpic" alt="">
  <a v-show="hideadv" :href=bindurl class="ads"><img v-bind:src="adv" v-lazy="adv" alt=""></a>
</div>

</template>
<script>
// import topNav from "../topnav/topnav"
export default {
  name: 'inoutdetail',
  components:{
    //  topNav,
  },
  data() {
    return {
      // title:"通知详情",
      // // topShow:false
      hideadv:true,
      carpic:require("../../../static/images/adv.png"),
      bindurl:"",
      adv:require("../../../static/images/adv.png")
    }
  },
  mounted(){
      let carpic=this.commonUtil.getUrlKey("carPic");
      if (!carpic){
        carpic = sessionStorage.getItem("carPic");
      }
      
      let bindurl=this.commonUtil.getUrlKey("bindUrl");

      if (!bindurl){
        bindurl = sessionStorage.getItem("bindurl");
      }

      if(this.commonUtil.isEmpty(carpic))
      {
        carpic=sessionStorage.getItem("carPic");
        bindurl=sessionStorage.getItem("bindUrl");
      }else{
        sessionStorage.setItem("carPic",carpic);
        sessionStorage.setItem("bindUrl",bindUrl);
      }
      this.carpic=carpic;
      this.bindurl=bindurl;

      if(this.commonUtil.isEmpty(bindurl))
      {
        this.hideadv=false;
      }

  }


}
</script>
<style>
.ads img {
    width: 98%;
    margin-top: 5%;
}
.carpic{
  width: 98%;
}
</style>




// WEBPACK FOOTER //
// src/components/paydetail/inoutdetail.vue